import React from "react";
import appPath from "utils/appPath";
import Message from "utils/Message";
import styles from "./styles.module.scss";

const CloseLink = () => {
    if (!appPath.isIframePath()) {
        return null;
    }

    const onClick = (e) => {
        e.preventDefault();
        Message.userCloseWindow();

        return;
    };

    return <button className={ styles.closeLink } aria-label="close" type="button" onClick={ onClick } />;
};

CloseLink.propTypes = {};

export default CloseLink;
